import { render, staticRenderFns } from "./AreaSelect.vue?vue&type=template&id=5d536c0e&"
import script from "./AreaSelect.ts?vue&type=script&lang=ts&"
export * from "./AreaSelect.ts?vue&type=script&lang=ts&"
import style0 from "./AreaSelect.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports